import { render, staticRenderFns } from "./CmsDetails.vue?vue&type=template&id=72d45882&"
import script from "./CmsDetails.vue?vue&type=script&lang=js&"
export * from "./CmsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports